'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadCrumb = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _breadcrumb = require('antd/lib/breadcrumb');

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _navLink = require('../navLink');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BreadCrumb = exports.BreadCrumb = (_temp = _class = function (_React$PureComponent) {
  _inherits(BreadCrumb, _React$PureComponent);

  function BreadCrumb() {
    _classCallCheck(this, BreadCrumb);

    return _possibleConstructorReturn(this, (BreadCrumb.__proto__ || Object.getPrototypeOf(BreadCrumb)).apply(this, arguments));
  }

  _createClass(BreadCrumb, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          navs = _props.navs,
          links = _props.links,
          extra = _props.extra;


      return _react2.default.createElement(
        'div',
        { className: 'j-com-breadcrumb ' + className, style: style },
        _react2.default.createElement(
          _breadcrumb2.default,
          null,
          navs.map(function (item, index) {
            if (item.link) {
              return _react2.default.createElement(
                _breadcrumb2.default.Item,
                { key: index },
                _react2.default.createElement(
                  _this2.props.Link,
                  { to: item.link },
                  item.text
                )
              );
            } else {
              return _react2.default.createElement(
                _breadcrumb2.default.Item,
                { key: index },
                item.text
              );
            }
          }),
          links || extra ? _react2.default.createElement(
            _breadcrumb2.default.Item,
            { className: 'j-breadcrumb-extra' },
            links && _react2.default.createElement(_navLink.NavLink, { links: links }),
            extra
          ) : null
        ),
        this.props.combox
      );
    }
  }]);

  return BreadCrumb;
}(_react2.default.PureComponent), _class.parse = function (route, subRoutes) {
  var navs = [];
  if (route) {
    navs.push({
      text: route.title
    });
    if (route.navKey && subRoutes[route.navKey]) {
      navs.unshift({
        text: subRoutes[route.navKey].title || route.navKey
      });
    }
    while ((route = route.parent) && route.title) {
      navs.unshift({ link: route.resolvePath, text: route.title });
    }
  }
  return navs;
}, _class.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  Link: _propTypes2.default.any,
  combox: _propTypes2.default.element,
  navs: _propTypes2.default.array,
  links: _propTypes2.default.array,
  extra: _propTypes2.default.any
}, _class.defaultProps = {
  className: '',

  Link: _reactRouter.Link,
  navs: []
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/breadCrumb/index.jsx
// module id = 18
// module chunks = 0